class Event {
  constructor() {
    this.hdmiRepeater = false
  }
  async _init() {
    return true
  }

  async resolve(event, data = null) {
    let _event = {}
    if (!event.type) {
      event = {
        type: event,
        detail: data
      }
    }
    /* Platform-specific Event */
    if (event.type === "mouseEvent") {
      _event.name = event.detail.state ? "airMouseActive" : "airMouseDeactive"
      _event.data = event.detail.state
    } else if (event.type === "audioEvent") {
      _event.name = "volumeChanged"
      _event.data = await __.device.volume()
    } else if (event.type === "platformEvent") {
      if (event.detail.state === "focused") _event.name = "applicationFocusing"
      else _event.name = "applicationUnfocused"
    } else if (event.type === "mediaEvent") {
      let tempName
      switch (event.detail.state) {
        case "playing":
          tempName = "mediaPlaying"
          break
        case "ended":
          tempName = "mediaEnded"
          break
        case "stopped":
          tempName = "mediaStopped"
          break
        case "paused":
          tempName = "mediaPaused"
          break
        case "encounteredError":
          tempName = "mediaError"
          break
        default:
          return false
      }
      _event.name = tempName
    } else if (["playing", "ended", "stopped", "pause", "error"].indexOf(event.type) >= 0) {
      let tempName
      switch (event.type) {
        case "playing":
          tempName = "mediaPlaying"
          break
        case "ended":
          tempName = "mediaEnded"
          break
        case "pause":
          tempName = "mediaPaused"
          break
        case "stopped":
          tempName = "mediaStopped"
          break
        default:
          tempName = "mediaError"
          break
      }
      _event.name = tempName
    } else if (event.type === "hdmiEvent") {
      if (!event.detail.state) {
        _event.name = "hdmiSinkDevice"
        _event.data = "turnedOff"
      } else {
        if (this.hdmiRepeater) return false
        else this.hdmiRepeater = true

        _event.name = "hdmiSinkDevice"
        _event.data = "turnedOn"

        _$.sleep(2000)
          .then(() => playmore.device.displayMode && __._api.hdmiSync())
          .finally(() => (this.hdmiRepeater = false))
      }
    } else if (event.type === "messageEvent") {
      let socketData = null
      try {
        socketData = window.atob(event.detail.state)
        socketData = JSON.parse(socketData)
      } catch (e) {
        return _$.error(e)
      }
      if (socketData.hasOwnProperty("action")) _$.vue.$emit("action", socketData)
      else if (socketData.hasOwnProperty("weather")) _$.vue.$emit("weather", socketData)
      else if (socketData.hasOwnProperty("chromecast")) _$.vue.$emit("chromecast", socketData)
      else if (socketData.hasOwnProperty("rc")) _$.vue.$emit("rc-command", socketData)
      return false
    }
    return _event
  }
}

export default Event
